<template>
  <div class="navs">
    <div class="logo">
      <img src="../assets/log.png" alt="">
    </div>
    <router-link :to="item.url" v-for="(item,index) in nanData" :key="index">{{item.name}}</router-link>

  </div>
</template>

<script>
export default {
  name: "navs",
  data() {
    return {
      nanData: [
        {name:'首页',url:'/index'},
        {name:'关于我们',url:'/intro'},
        {name:'产品展示',url:'/product'},
        {name:'系统方案',url:'/system'},
        {name:'软件定制',url:'/software'},
        {name:'新闻动态',url:'/company'},
        {name:'联系我们',url:'/aboutUS'},
      ],
    }
  }
}
</script>

<style scoped>
  .navs{
    height: 70px;
    width:1200px;
    line-height: 70px;
    margin: 0 auto;
  }
  .navBar{
    vertical-align: middle;
  }

  a {
    width: 85px;
    text-align: center;
    display: block;
    float: left;
    text-decoration: none;
    color: #333;
  }
  span {
    font-size: 28px;
    color: rgba(102, 102, 102, 1);
  }
  .navs a.router-link-exact-active,
  .navs a:hover{
    color: rgba(0,106,184,1);
    font-weight: bolder;
  }
  .logo{
    float: left;
    padding-top: 15px;
    box-sizing: border-box;
    margin-right: 130px;
  }
  .logo img{
    height: 35px;
  }
  .call{
    float: left;
    margin-left: 50px;
    display: flex;
    justify-content: space-between;
    padding-top: 22px;
    box-sizing: border-box;
    line-height: 27px;
  }

</style>